import axios from 'axios';

// Change this to your actual production API URL later
// const API_URL =  'http://localhost:5000/api';
const API_URL =  'https://envdock.cloud/api';

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor to automatically attach the token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const adminService = {
  // Auth
  login: (email, password) => api.post('/auth/login', { email, password }),
  
  // Dashboard Stats
  getStats: () => api.get('/superadmin/stats'),
  
  // Feedbacks/Tickets
  getFeedbacks: () => api.get('/superadmin/feedbacks'),
  updateFeedbackStatus: (id, status) => api.patch(`/superadmin/feedbacks/${id}/status`, { status }),
};

export default api;